export const globalMixins = {
    methods: {
        showNotificationAlert: function (title, text, type){
            this.$notify({
            group: "saved",
            title: title,
            text: text,
            type: type
            })
        },
    }
  }
  